import React,{useState,useEffect} from "react";
import { IoMail } from "react-icons/io5";
import styled from "styled-components";
import Quote from "../Components/Quote";

const Contact = () => {
  const [navText, setNavText] = useState("");
  useEffect(() => {
    const handleWindowResize = () => {
      const windowWidth = window.innerWidth;
      setNavText(windowWidth < 960 ? "Navbar" : "Sidebar");
    };

    handleWindowResize(); // Set initial value

    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);
  return (
    <ContactBox className="contact-container">
      <div className="contact-wrapper">
        <p data-aos="fade-up" data-aos-delay="100">
          Thanks for reading through!
        </p>
        <h2 data-aos="fade-up" data-aos-delay="200">
          Get In Touch With Me
        </h2>
        <p data-aos="fade-up" data-aos-delay="300">
          you can reach me through the links in the <em>{navText}</em> , Or send a
          mail through this link
        </p>
        <a
          data-aos="fade-up"
          data-aos-delay="400"
          href="mailto:greatsoma2019@gmail.com"
          id="contact-btn"
        >
          <IoMail /> Email
        </a>
      </div>
      <Quote/>
    </ContactBox>
  );
};
const ContactBox = styled.div`
  width: 100%;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .contact-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .contact-wrapper p {
    font-size: 1.2rem;
    font-weight: 300;
    color: #fff;
  }
  .contact-wrapper p em {
    font-weight: bold;
  }
  .contact-wrapper h2 {
    font-size: 3.5rem;
    font-weight: 700;
    color: #8f6ebe;
    font-family: "Quantico";
    filter: drop-shadow(5px 8px 2px black);
  }
  .contact-wrapper a {
    font-size: 1.2rem;
    font-weight: 300;
    color: #fff;
    text-decoration: none;
    padding: 0.5rem 1rem;
    border-radius: 10px;
    box-shadow: -4px -5px 6px 0px #363636, 4px 5px 6px #000;
    background: #8f6ebe;
    transition: all 0.3s ease-in-out;
  }
  .contact-wrapper a:hover {
    box-shadow: -4px -5px 6px 0px #000, 4px 5px 6px #363636;
  }
  @media screen and (max-width: 960px) {
    .contact-wrapper {
      width: 90%;
    }
  }
`;
export default Contact;
